import getters from './getters'
import { actions as actions } from './actions'
import { mutations } from './mutations'

const state = {
  current: {
    loading: true,
    data: null,
    error: false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/checkin/index.js
// module id = null
// module chunks = 